<template>
  <v-list-item
    :class="[{ 'external-unit-card': unit.isExternal }]"
    @click="$emit('toggle-details')"
  >
    <v-img
      contain
      height="65"
      max-width="130"
      class="ma-a mr-4"
      :src="unit.photoUrl.size200x200"
    />

    <v-list-item-content>
      <v-list-item-title class="font-weight-medium d-flex align-center">
        {{ unit.title }}
      </v-list-item-title>
    </v-list-item-content>

    <v-list-item-action-text>
      <v-btn icon text small>
        <v-icon>
          {{ showDetails ? "mdi-chevron-up" : "mdi-chevron-right" }}
        </v-icon>
      </v-btn>
    </v-list-item-action-text>

    <div
      v-if="unit.isExternal"
      class="external-label blue lighten-4 rounded-l-0 rounded-tr"
    >
      <span
        class="external-text blue--text text--darken-4 font-weight-medium text-caption uppercase"
      >
        Extern
      </span>
    </div>
  </v-list-item>
</template>

<script>
export default {
  name: "UnitHeader",
  props: {
    unit: {
      type: Object,
      required: true,
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.external-unit-card {
  position: relative;
  padding-right: 20px;
}

.external-label {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.external-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: rotate(180deg);
}
</style>
